import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';

import {apiTokenChildGuard} from './guards/api-token.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  },
  {
    path: '',
    canActivateChild: [apiTokenChildGuard],
    children: [
      {
        path: 'sbandieratori',
        loadChildren: () => import('./pages/sbandieratore/sbandieratore-list/sbandieratore-list.module').then(m => m.SbandieratoreListModule)
      },
      {
        path: 'sbandieratori/new',
        loadChildren: () => import('./pages/sbandieratore/sbandieratore-detail/sbandieratore-detail.module').then(m => m.SbandieratoreDetailModule)
      },
      {
        path: 'sbandieratori/:id',
        loadChildren: () => import('./pages/sbandieratore/sbandieratore-detail/sbandieratore-detail.module').then(m => m.SbandieratoreDetailModule)
      },
      {
        path: 'esibizioni',
        loadChildren: () => import('./pages/esibizione/esibizione-list/esibizione-list.module').then(m => m.EsibizioneListModule)
      },
      {
        path: 'esibizioni-archivio',
        loadChildren: () => import('./pages/esibizione/esibizione-archive/esibizione-archive.module').then(m => m.EsibizioneArchiveModule)
      },
      {
        path: 'esibizioni/new',
        loadChildren: () => import('./pages/esibizione/esibizione-detail/esibizione-detail.module').then(m => m.EsibizioneDetailModule)
      },
      {
        path: 'esibizioni/:id',
        loadChildren: () => import('./pages/esibizione/esibizione-detail/esibizione-detail.module').then(m => m.EsibizioneDetailModule)
      },
      {
        path: 'statistiche',
        loadChildren: () => import('./pages/statistiche/statistiche.module').then(m => m.StatisticheModule)
      },
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
